import React, { useState } from "react";

const TeachingHoursCalculator = () => {
  const [weeks, setWeeks] = useState("");
  const [hoursPerWeek, setHoursPerWeek] = useState("");
  const [totalHours, setTotalHours] = useState(null);

  const calculateHours = () => {
    setTotalHours(weeks * hoursPerWeek);
  };

  return (
    <div className="p-6 bg-gray-100 rounded-lg shadow-lg mx-auto mt-5">
      <h2 className="text-xl font-bold text-center text-blue-600">Teaching Hours Calculator</h2>
      <input type="number" placeholder="Weeks in a Term" className="border p-2 w-full mt-3" onChange={(e) => setWeeks(e.target.value)} />
      <input type="number" placeholder="Teaching Hours per Week" className="border p-2 w-full mt-3" onChange={(e) => setHoursPerWeek(e.target.value)} />
      <button className="mt-4 bg-blue-500 text-white py-2 px-4 rounded w-full" onClick={calculateHours}>Calculate</button>
      {totalHours && <div className="mt-3 text-center text-lg">Total Teaching Hours: <span className="font-bold text-green-600">{totalHours} hrs</span></div>}
    </div>
  );
};

export default TeachingHoursCalculator;
